import logo from "././../Assets/Icons/logo3.png";
import { Tabs as AntTabs, Spin } from "antd";
import Home from "./Home";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import loginImage from "././../Assets/Icons/login.svg";
import CustomNavLink from "./CustomNavLink";
import CandidateLogin from "./CandidateLogin";
import { FaCaretDown } from "react-icons/fa6";
import { Dropdown, Space, Avatar } from "antd";
import { Button, message, Popconfirm, Modal } from "antd";
import { PiWarningCircleLight } from "react-icons/pi";
import { UserOutlined } from "@ant-design/icons";
import AuthService from "../Service.js/authService";

const Header = () => {
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("Home");
  const [isLogout, setIsLogout] = useState(false);
  const [logo, setLogo] = useState();
  const [loading, setLoading] = useState(false);
  const [isCandidateLogin, setCandidateLogin] = useState(false);
  const [isEmployeLogin, setEmployeLogin] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  let isLogin = urlParams.get("isLogin");
  const isLoginPage = location.pathname === "/login";
  const isSignupPage = location.pathname === "/signup";

  useEffect(() => {
    if (isLogin == "true") {
      setOpen(true);
    }
  }, [isLogin]);

  useEffect(() => {
    if (
      location?.pathname?.includes("/signup/") &&
      currentUser &&
      Object.keys(currentUser).length > 0
    ) {
      console.log(currentUser, "currentUser");
      localStorage.removeItem("candidate");
      setLoading(true);
      const timeOutId = setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  }, []);

  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };
  useEffect(() => {
    getLogo();
  }, []);

  const handleClick = ({ key }) => {
    setIsLogout(true);
  };
  const profileDetails = ({ key }) => {
    navigate("/profile");
  };
  const documentDetails = ({ key }) => {
    navigate("/documents");
  };
  const myjobs = ({ key }) => {
    navigate("/myJobs");
  };
  const viewassessment = ({ key }) => {
    navigate("/viewAssessment");
  };
  const items = [
    {
      label: "My Profile",
      key: "0",
      onClick: profileDetails,
    },
    // {
    //     label: "My Document",
    //     key: '1',
    //     onClick: documentDetails
    // },

    {
      label: "My Jobs",
      key: '1',
      onClick: myjobs
    },
    // {
    //     label: "Review Pending",
    //     key: '1',
    //     onClick: documentDetails
    // },
    {
      label: "Assessments",
      key: '3',
      onClick: viewassessment
    },
    {
      label: "Logout",
      key: "4",
      onClick: handleClick,
    },
  ];
  const handleLogout = () => {
    localStorage.removeItem("candidate");
    localStorage.removeItem("user_id");
    navigate("/");
    window.location.reload();
  };
  const modalContent = (
    <div>
      <p className="text-[#000] text-xl font-bold  mt-4 flex item-center justify-center">
        <PiWarningCircleLight
          className="w-20 h-20"
          style={{
            display: "flex",
            fontSize: "48px",
            color: "#52c41a",
            paddingBottom: "25px",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        />
      </p>
      <p className="flex justify-center mb-4 text-lg font-bold item-center">
        Logout
      </p>
      <p className="text-[#000] flex item-center justify-center">
        Are you sure want to logout?{" "}
      </p>
      <div className="flex justify-end">
        <Button
          className="bg-[#1C4980] text-white text-base"
          onClick={handleLogout}
        >
          Logout
        </Button>
      </div>
    </div>
  );

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
    navigate("/");
  };
  const candidateOnClose = () => {
    setOpen(false);
  };
  const close = () => {
    setOpen(false);
  };
  const handleLogin = () => {
    navigate("login");
  };


  const handleClicks = () => {
    if (isLoginPage) {
      navigate("/signup"); // go to signup when on login page
    } else {
      navigate("/login"); // go to login when on signup page
    }
  };

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center h-60">
          <Spin />
        </div>
      ) : (
        <div className="flex items-center justify-center dark:bg-[#1A1D21]  ">
          <div className="w-full md:w-3/4">
            <div className="flex flex-row justify-between ">
              

              {currentUser === null && location.pathname === "/signup/" || location.pathname === "/login/" ? (
                <>
                  <div className="mt-8">
                  </div>
                </>
              ) : currentUser === null && location.pathname === "/login/" ? (
                <>
                  <div className="mt-8">
                  </div>
                </>
              ) : currentUser === null ? (
                <>
                  <div className="flex flex-wrap mt-8 space-x-6">
                    <div className="flex items-center justify-end w-full">
                      {isLoginPage ? (
                        <div className="flex items-center justify-center gap-2 ml-4 md:gap-4">
                          <p className="text-sm text-center text-gray-600 md:text-base sm:text-left">
                            Don't have an account?
                          </p>
                          <Link
                            to="/signup"
                            className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0 "
                          >
                            Sign Up Now
                          </Link>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center gap-2 ml-4 md:gap-4">
                          {isSignupPage && (
                            <p className="text-sm text-gray-600 md:text-base">
                              Do you have an account?
                            </p>
                          )}
                          <Link
                            to="/login"
                            className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
                          >
                            Sign In
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>

                  {open && (
                    <CandidateLogin open={open} onClose={candidateOnClose} />
                  )}
                </>
              ) : (
                <div className="flex mt-8">
                  <div className="px-2">{currentUser.first_name}</div>
                  <div className="pl-2">
                    <Dropdown
                      menu={{
                        items,
                      }}

                    >
                      <a onClick={(e) => e.preventDefault()}>
                        <Space>
                          <FaCaretDown />
                        </Space>
                      </a>
                    </Dropdown>
                  </div>
                </div>
              )}



            </div>
            <div className="h-[1px] mt-6"></div>
            {isLogout && (
              <Modal
                className="settingsPage"
                title={""}
                open={isLogout}
                width={500}
                onCancel={() => setIsLogout(false)}
                footer={null}
              >
                {modalContent}
               
              </Modal>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Header;
